import {HttpRequest,HttpMethod} from "./http";

class WmsProvider extends HttpRequest {
    StorageCreate(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/storage`, params);
    }
    StorageUpdate(id,payload) {
        return this.request(HttpMethod.Put,`/api/v1/wms/storage/${id}`, payload);
    }
    StorageDelete(id) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/storage/${id}` );
    }
    StorageList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/storage`, params);
    }

    PartnerCreate(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/partner`, params);
    }
    PartnerUpdate(id,payload ) {
        return this.request(HttpMethod.Put,`/api/v1/wms/partner/${id}` , payload);
    }
    PartnerDelete(id) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/partner/${id}` );
    }
    PartnerList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/partner`, params);
    }

    ProductCreate(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/product`, params);
    }
    ProductUpdate(id,payload) {
        return this.request(HttpMethod.Put,`/api/v2/wms/product/${id}` , payload);
    }
    ProductDelete(id) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/product/${id}` );
    }
    ProductList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/product`, params);
    }
	ProductGetBarcode(params) {
        return this.request(HttpMethod.Get,`/api/v1/util/barcode`, params);
    }

    InventoryList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/inventory`, params);
    }
    InventoryHistory(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/inventory/history`, params);
    }
    InventoryHistoryDetail(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/inventory/historydetail/` + params);
    }
	InventoryListByStorage(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/inventory/history/linepack`, params);
	}
    // InventoryIn(params) {
    //     return this.request(HttpMethod.Post,`/api/v1/wms/inventory/item/in`, params);
    // }
    // InventoryOut(params) {
    //     return this.request(HttpMethod.Post,`/api/v1/wms/inventory/item/out`, params);
    // }
    // InventoryTransfer(params) {
    //     return this.request(HttpMethod.Post,`/api/v1/wms/inventory/item/group/move`, params);
    // }
	InventoryIn(params) {
        return this.request(HttpMethod.Post,`/api/v2/wms/inventory/item/in`, params);
    }
    InventoryOut(params) {
        return this.request(HttpMethod.Post,`/api/v2/wms/inventory/item/out`, params);
    }
    InventoryTransfer(params) {
        return this.request(HttpMethod.Post,`/api/v2/wms/inventory/item/group/move`, params);
    }
    InventoryTransferByUser(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/inventory/user/move`, params);
    }
    InventoryDelete(params) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/inventory/${params}` );
    }

    PromotionCreate(params) {
        return this.request(HttpMethod.Post,`/api/v1/wms/profile/pickup/create`, params);
    }
    PromotionDelete(params) {
        return this.request(HttpMethod.Delete,`/api/v1/wms/profile/pickup/${params}`);
    }
    PromotionList(params) {
        return this.request(HttpMethod.Get,`/api/v1/wms/profile/pickup`, params);
    }

	ProductWaitShipList(params) {
        return this.request(HttpMethod.Get,`/api/v1/orders/product/wait/shipment`, params);
    }

	WmsInventorySummary(params){
        return this.request(HttpMethod.Get,`/api/v1/wms/inventory/summary`,params );
	}

}

export default WmsProvider;
